import { DetailNotification } from './models/detail-notification';
import { ListNotifications } from './models/list-notifications';
import { Faq } from './models/faq';
import { endpoints, environment } from './../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, ApplicationRef } from '@angular/core';
import { Auth } from '../autentication/Auth';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ExtractService } from '../master/extract/extract.service';
import { Moment } from 'moment';
import { PixNotification } from '../master/pix/models/notification.model';
import { BaseResult } from './models/base.result.model';
import { Util } from '../utils/util';

@Injectable()
export class SharedService {
	public listNotifications: Array<ListNotifications> = new Array<ListNotifications>();
	public listFaqs: Array<Faq> = new Array<Faq>();
	public detailNotification: DetailNotification;
	private _rerender = new BehaviorSubject<boolean>(false);
	public dateBegin: any;
	public dateEnd: any;
	private urlPix = endpoints.pix;

	constructor(
		private http: HttpClient,
		private appRef: ApplicationRef) {
	}

	// Observable rerender stream
	rerender$ = this._rerender.asObservable();

	// service command
	changeRerender(val: boolean) {
		this._rerender.next(val);
		this.appRef.tick();
		this._rerender.next(!val);
	}

	public get reRendering(): boolean {
		return this._rerender.value;
	}

	getListNotificationsPix(
		inicial: number,
		dataHoraInicial: string,
		dataHoraFinal: string,
		quantidade: number
	): Observable<BaseResult<PixNotification[]>> {
		return this.http.get<BaseResult<PixNotification[]>>(`${this.urlPix.notifications}?
				inicial=${inicial}&
				dataHoraInicial=${dataHoraInicial}&
				dataHoraFinal=${dataHoraFinal}&
				quantidade=${quantidade}`);
	}

	getBalance(): Observable<any> {
		return this.http.get(endpoints.accounts.balance);
	}

	getListNotifications(): Observable<ListNotifications[]> {
		return this.http.get(endpoints.accounts.notifications).pipe(map((data: any) => {
			if (data.Sucesso) {
				if (data.Retorno && data.Retorno.length) {
					this.listNotifications = data.Retorno.map(data => {
						const item = new ListNotifications();
						item.notificationRead = data.MensagemLida;
						item.notificationList = data.MensagemListada;
						item.notificationId = data.ID;
						item.messageTitle = data.TituloMensagem;
						item.messageContent = data.ConteudoMensagem;
						item.date = moment(data.DataHoraMensagem).format('DD/MM/YYYY [as] HH:mm[h]');
						item.dateTime = new Date(data.DataHoraMensagem);
						return item;
					});

				} else {
					this.listNotifications = [];
				}

			}
			return this.listNotifications;
		}));
	}

	getNotificationDetail(detailId: number): Observable<DetailNotification> {
		return this.http.get(endpoints.accounts.notifications + detailId).pipe(map((data: any) => {

			const item = data.Retorno;
			const list = new DetailNotification();

			if (data.Sucesso) {

				if (item.TipoNotificacao === 'autorizarTransacao') {
					list.buttonLink = '/transacoes/';
					list.buttonDescription = 'Autorizar transação';
				}

				list.notificationId = item.ID;
				list.messageTitle = item.TituloMensagem;
				list.messageContent = item.ConteudoMensagem;
				list.date = moment(item.DataHoraMensagem).format('DD/MM/YYYY [as] HH:mm[h]');
				return list;
			}
			return this.detailNotification;

		}));
	}

	sendReceiptsToEmail(transferNumber: number, receiptType: string, fileType: string, desiredEmail: string): Observable<any> {
		return this.http.post(endpoints.receipts.sendEmail + `
			${transferNumber}/
			${receiptType}/
			${fileType}/
			email`, {
			EmailDestinatario: desiredEmail ? desiredEmail : null
		});
	}

	sendExtractReceiptsToEmail(startDate: any, endDate: any, fileType: string, desiredEmail: string): Observable<any> {
		startDate = this.dateBegin;
		endDate = this.dateEnd;

		if (endDate === null) {
			return this.http.post(endpoints.bankStatement.generalV2 + `/
			${startDate}/
			${fileType}/
			email`, {
				EmailDestinatario: desiredEmail ? desiredEmail : null
			});
		}

		return this.http.post(endpoints.bankStatement.generalV2 + `/
			${startDate}/
			${endDate}/
			${fileType}/
			email`, {
			EmailDestinatario: desiredEmail ? desiredEmail : null
		});
	}

	downloadFile(transferNumber: number, receiptType: string, fileType: string): Observable<any> {
		return this.http.get(endpoints.receipts.all + `/
			${transferNumber}/
			${receiptType}/
			${fileType}/
			download`, {
		}).pipe(map((data: any) => {
			return data.Retorno;
		}));
	}

	getBankSlip(params): Observable<any> {
		return this.http.post(endpoints.deposits.pdf, params).pipe(map((data: any) => {
			return data.Retorno;
		}));
	}

	getReportIncome(params): Observable<any> {
		return this.http.get(endpoints.accounts.reportIncome + '/' + params.ano + '/PDF/download').pipe(map((data: any) => {
			return data.Retorno;
		}));
	}

	sendReportIncomeToEmail(year, email): Observable<any> {
		return this.http.post(endpoints.accounts.reportIncome + '/' + year + '/PDF/email', { emailDestinatario: email }).pipe(map((data: any) => {
			return data.Retorno;
		}));
	}

	sendBankSlip(params): Observable<any> {
		return this.http.post(endpoints.deposits.sendEmail, params).pipe(map((data: any) => {
			return data.Retorno;
		}));
	}

	downloadExtractFile(dateBegin: any, dateEnd: any, fileType: string): Observable<any> {
		const beginDate = this.dateBegin;
		const endDate = this.dateEnd;

		if (endDate === null) {
			return this.http.get(endpoints.bankStatement.generalV2 +
				`/
				${beginDate}/
				${fileType}/
				download`, {
			}).pipe(map((data: any) => {
				return data.Retorno;
			}));
		}

		return this.http.get(endpoints.bankStatement.generalV2 +
			`/
			${beginDate}/
			${endDate}/
			${fileType}/
			download`, {
		}).pipe(map((data: any) => {
			return data.Retorno;
		}));
	}

	deleteNotification(id: number): Observable<any> {
		return this.http.delete(endpoints.accounts.notifications + id);
	}

	acceptTerms(): Observable<any> {
		return this.http.post(endpoints.accounts.users +
			Auth.cpf + endpoints.accounts.terms, {});
	}

	getListFaqs(): Observable<Faq[]> {
		return this.http.get(endpoints.utils.faqs).pipe(map((data: any) => {
			if (data.Sucesso) {
				if (data.Retorno.TotalRegistros > 0) {
					let faq: Faq;
					this.listFaqs = data.Retorno.FAQs.map(item => {
						faq = {
							id: item.ID,
							question: item.Pergunta,
							answer: item.Resposta
						}
						return faq;
					});
				} else {
					this.listFaqs = [];
				}
			}
			return this.listFaqs;
		}));
	}

	addHelpDesk(): Observable<any> {
		return this.http.get(endpoints.utils.addHelpDesk).pipe(map((data: any) => {
			return data;
		}));
	}

	getDateBlockValidation(
		tipo: string,
		data: Date,
	): Observable<any> {
		const dataDePagamento = (data && Util.isToday(data)) ? null : data;
		const params = new HttpParams()
			.set('tipoPagamento', tipo)
			.set('dataDePagamento', dataDePagamento ? dataDePagamento.toISOString().split('T')[0] : null);
		return this.http.get(endpoints.dateBlockValidation, { params });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/shared.service.ts